import { AppRoutes } from '../../interfaces/store/appStore'
import { Browser, getBrowser, isChromeBasedBrowser, isMobileDevice } from '../../utils'

const BROWSER_DISPLAY_NAMES: Record<Browser, string> = {
    chrome: 'Google Chrome',
    edge: 'Microsoft Edge',
    opera: 'Opera',
    brave: 'Brave',
    firefox: 'Firefox',
    safari: 'Safari',
    other: 'your current browser',
}

export const getBrowserDisplayName = (browser: Browser = getBrowser()): string =>
    BROWSER_DISPLAY_NAMES[browser] ?? BROWSER_DISPLAY_NAMES.other

/** Mobile only — auto-skip extension on signup. Non-Chromium uses UnsupportedBrowserSection. */
export const shouldBypassExtensionInstall = (): boolean => isMobileDevice()

export const getOnboardingFirstStepRoute = (): string => {
    if (isMobileDevice()) return AppRoutes.ONBOARDING_SURVEY
    return isChromeBasedBrowser()
        ? AppRoutes.ONBOARDING_EXTENSION_INSTALL
        : AppRoutes.ONBOARDING_UNSUPPORTED_BROWSER
}
